// removed by extract-text-webpack-plugin
module.exports = {"gwWizardTileLabelDefault":"tile-label-hashed__gwWizardTileLabelDefault__f4ih-","gwWizardTileLabelSmall":"tile-label-hashed__gwWizardTileLabelSmall__2JaQx","gwWizardTileLabelActive":"tile-label-hashed__gwWizardTileLabelActive__QcUlQ"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/tileLayout/Label/tile-label-hashed.scss
// module id = 1224
// module chunks = 0